<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import type { ClassValue } from "svelte/elements";
	import newsPlaceholder from "@core/assets/images/news-placeholder.svg";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import type { PublicArticle } from "@core/schema/PublicArticle.js";
	import { getNewsDetailPath } from "@core/schema/paths/getNewsDetailPath.js";
	import { formatDateDDMMYYYY } from "@core/utils/formatDateDDMMYYYY.js";
	import Button from "./common/Button.svelte";
	import Media from "./common/Media.svelte";

	const { article, class: customClass }: { article: PublicArticle; class?: ClassValue } = $props();
	const publishedDate = $derived(new Date(article.publishedAt));
	const formattedDate = $derived(formatDateDDMMYYYY(publishedDate));
</script>

<div class={[customClass, "bg-white/50 backdrop-blur-lg rounded-xl md:rounded-3xl p-2 sm:p-4"]}>
	<a
		class="grid grid-cols-[min(50%,10.25rem)_1fr] xs:grid-cols-[min(50%,36.625rem)_1fr] gap-4 sm:gap-6 lg:gap-8 group/underline h-full"
		href={getNewsDetailPath(article)}
	>
		<div class="rounded-lg overflow-hidden shrink-0 md:min-h-[18rem]">
			<Media
				source={article.primaryImage ?? {
					src: newsPlaceholder,
					type: "image/svg+xml",
				}}
				width={550}
				height={288}
				draggable={false}
				alt="Obrázek článku „{article.title}“"
				class="size-full object-cover"
				wrapperClass="rounded-lg overflow-hidden shrink-0"
				sourcesets={{
					"<2xl": [300, 0],
					">2xl": [300, 0],
				}}
			/>
		</div>
		<div class="flex flex-col gap-6 sm:gap-6 lg:gap-8 justify-between items-start 2xl:w-full lg:flex-grow">
			<div class="flex flex-col gap-3 sm:gap-4 lg:gap-5">
				<time
					datetime={publishedDate.toISOString()}
					class="text-[0.5rem] leading-[0.6rem] sm:text-2xs sm:leading-3 font-inter text-cmcsecondary font-medium"
				>
					{formattedDate}
				</time>
				<h3
					class="text-base/[1] leading-tight sm:text-xl sm:leading-snug lg:text-2xl lg:leading-[1.813rem] font-bold text-cmcsecondary"
				>
					<Formatted text={article.title} />
				</h3>
				<p
					class="font-medium text-2xs/[1.6] sm:text-xs sm:leading-[1.4] lg:leading-[1.6] line-clamp-5 md:line-clamp-[9] lg:line-clamp-[7]"
				>
					<Formatted text={article.perex} />
				</p>
			</div>
			<div>
				<Button type="span" variant={ButtonVariant.Text} icon="arrow" class="mt-auto">
					<Formatted text="hover[[Číst více]]" />
				</Button>
			</div>
		</div>
	</a>
</div>
